
import BusinessSolutions from "../Components/BusinessSolution/BusinessSolution";
import MethodologySection from "../Components/MethodologySection/MethodologySection";
import SuccessInAction from "../Components/Technology-component/Everything";
import Header from "../Components/Technology-component/Header";

function Technology() {
    return (
      <div>
        <Header/>
       <MethodologySection/>
       <BusinessSolutions/>
       <SuccessInAction/>
      </div>
    );
  }
  
  export default Technology;